import {observable} from 'mobx';
import {createInstance, ModelProperties} from '../utils';
import {Language} from './language';

export class Audio {
    @observable id!: number;

    @observable text!: string;

    @observable audioKey!: string;

    @observable languageId!: number;

    @observable wordId!: number;

    @observable language?: Language;

    constructor(audio?: ModelProperties<Audio>) {
        if (audio) {
            Object.assign(this, audio);
            this.language = createInstance(Language, audio.language);
        }
    }
}